/**
 * Form Select Module
 * Zarządza zachowaniem custom selecta (otwarcie, zamknięcie, wybór opcji).
 * Synchronizuje zaznaczenie z ukrytym natywnym <select>.
 *
 * Użycie HTML:
 *   <div class="form-select">
 *     <label class="form-select__label">Label</label>
 *     <div class="form-select__wrapper">
 *       <select class="form-select__native" name="field" aria-hidden="true" tabindex="-1">
 *         <option value="">Wybierz z listy</option>
 *         <option value="1">Opcja 1</option>
 *       </select>
 *       <div class="form-select__trigger" role="combobox" aria-haspopup="listbox"
 *            aria-expanded="false" tabindex="0">
 *         <span class="form-select__value">Wybierz z listy</span>
 *         <span class="form-select__arrow"></span>
 *       </div>
 *       <ul class="form-select__dropdown" role="listbox">
 *         <li class="form-select__option" role="option" data-value="1">Opcja 1</li>
 *       </ul>
 *     </div>
 *   </div>
 */

(function () {
    'use strict';

    var SELECTOR = '.form-select';
    var CLASS_OPEN = 'form-select--open';
    var CLASS_DISABLED = 'form-select--disabled';

    /**
     * Otwiera dropdown
     */
    function openSelect(wrapper, trigger, dropdown) {
        wrapper.classList.add(CLASS_OPEN);
        trigger.setAttribute('aria-expanded', 'true');
    }

    /**
     * Zamyka dropdown
     */
    function closeSelect(wrapper, trigger) {
        wrapper.classList.remove(CLASS_OPEN);
        trigger.setAttribute('aria-expanded', 'false');
    }

    /**
     * Przełącza dropdown
     */
    function toggleSelect(wrapper, trigger, dropdown) {
        if (wrapper.classList.contains(CLASS_OPEN)) {
            closeSelect(wrapper, trigger);
        } else {
            openSelect(wrapper, trigger, dropdown);
        }
    }

    /**
     * Wybiera opcję: aktualizuje valueEl, natywny select oraz stan klas
     */
    function selectOption(wrapper, trigger, nativeSelect, valueEl, option) {
        var value = option.getAttribute('data-value');
        var text = option.textContent.trim();

        // Aktualizuj wyświetlany tekst
        valueEl.textContent = text;
        valueEl.classList.add('is-selected');

        // Aktualizuj wszystkie opcje
        var allOptions = wrapper.querySelectorAll('.form-select__option');
        allOptions.forEach(function (opt) {
            opt.classList.remove('is-selected');
            opt.setAttribute('aria-selected', 'false');
        });
        option.classList.add('is-selected');
        option.setAttribute('aria-selected', 'true');

        // Synchronizuj natywny select
        if (nativeSelect) {
            nativeSelect.value = value;
            // Wyzwól event change na natywnym select dla integracji z formularzami
            var changeEvent = new Event('change', { bubbles: true });
            nativeSelect.dispatchEvent(changeEvent);
        }

        // Zamknij dropdown
        closeSelect(wrapper, trigger);
        trigger.focus();
    }

    /**
     * Inicjalizuje jeden komponent .form-select
     */
    function initSelect(selectEl) {
        // Pomiń jeśli disabled
        if (selectEl.classList.contains(CLASS_DISABLED)) return;

        var wrapper = selectEl.querySelector('.form-select__wrapper');
        var trigger = selectEl.querySelector('.form-select__trigger');
        var dropdown = selectEl.querySelector('.form-select__dropdown');
        var valueEl = selectEl.querySelector('.form-select__value');
        var nativeSelect = selectEl.querySelector('.form-select__native');

        if (!wrapper || !trigger || !dropdown || !valueEl) return;

        // Kliknięcie triggera — otwórz/zamknij
        trigger.addEventListener('click', function (e) {
            e.stopPropagation();
            toggleSelect(wrapper, trigger, dropdown);
        });

        // Keyboard navigation
        trigger.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleSelect(wrapper, trigger, dropdown);
            } else if (e.key === 'Escape') {
                closeSelect(wrapper, trigger);
            } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (!wrapper.classList.contains(CLASS_OPEN)) {
                    openSelect(wrapper, trigger, dropdown);
                }
                var firstOption = dropdown.querySelector('.form-select__option');
                if (firstOption) firstOption.focus();
            }
        });

        // Obsługa opcji dropdown
        var options = dropdown.querySelectorAll('.form-select__option');
        options.forEach(function (option) {
            option.setAttribute('tabindex', '0');

            option.addEventListener('click', function (e) {
                e.stopPropagation();
                selectOption(wrapper, trigger, nativeSelect, valueEl, option);
            });

            option.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    selectOption(wrapper, trigger, nativeSelect, valueEl, option);
                } else if (e.key === 'Escape') {
                    closeSelect(wrapper, trigger);
                    trigger.focus();
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    var next = option.nextElementSibling;
                    if (next) next.focus();
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    var prev = option.previousElementSibling;
                    if (prev) {
                        prev.focus();
                    } else {
                        trigger.focus();
                    }
                }
            });
        });
    }

    /**
     * Globaly click — zamknij wszystkie otwarte selecty
     */
    function closeAllOnOutsideClick(e) {
        var allWrappers = document.querySelectorAll('.' + CLASS_OPEN);
        allWrappers.forEach(function (wrapper) {
            var trigger = wrapper.querySelector('.form-select__trigger');
            closeSelect(wrapper, trigger);
        });
    }

    /**
     * Inicjalizacja wszystkich komponentów
     */
    function init() {
        var elements = document.querySelectorAll(SELECTOR);
        if (!elements.length) return;

        elements.forEach(function (el) {
            initSelect(el);
        });

        // Zamykanie dropdown po kliknięciu poza nim
        document.addEventListener('click', closeAllOnOutsideClick);
    }

    // Inicjalizacja po załadowaniu DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
